import React from "react";

import DefaultCasinoIcon from "@pages/casino/assets/backgrounds/default-casino-icon.png";
import { PlayNowIcon, RemoveFromFavoriteIcon } from "@pages/casino/assets/icons";

import {
	CardWrapper,
	ContentWrapper,
	GameAffiliateName,
	GameName,
	ImageWrapper,
	PlayNowButton,
} from "./elements.js";
import useController from "./useController.js";

const FavoritesCard = ({ game, size, onRemoveFavorite, onPlay, ...props }) => {
	const {
		helpers: { translate },
		state: { isHovered, isMobile },
		handlers: { handleMouseEnter, handleMouseLeave },
	} = useController();

	return (
		<CardWrapper
			{...props}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}>
			<ImageWrapper
				id="game-image-wrapper"
				data-size={size}>
				<img
					data-size={size}
					className="big-image"
					src={game?.icon_custom_url || game?.game_icon_url || DefaultCasinoIcon}
					onError={(e) => {
						if (e.target.src !== DefaultCasinoIcon) {
							e.target.src = DefaultCasinoIcon;
						}
					}}
				/>
			</ImageWrapper>
			<ContentWrapper>
				<RemoveFromFavoriteIcon
					removeFromFav={isHovered || isMobile}
					className="fav-icon"
					onClick={() => onRemoveFavorite(game?.id, game?.is_live)}
				/>
				<GameAffiliateName>{game?.affiliate}</GameAffiliateName>
				<GameName>
					{game?.remote_name && game.remote_name.length > 41
						? `${game.remote_name.slice(0, 38)}...`
						: game.remote_name}
				</GameName>
				<PlayNowButton onClick={onPlay}>
					<PlayNowIcon />
					{translate("PLAY_NOW")}
				</PlayNowButton>
			</ContentWrapper>
		</CardWrapper>
	);
};

export default FavoritesCard;
